import { useCallback, useEffect, useState } from "react";
import apiCalls from "src/api/apiCalls";
import Loader from "src/components/loader.component";
import { NumericFormat } from 'react-number-format';
import { getKpis } from "../api";
import ProgramsList from "../programs.list";
import { Alert } from "antd";

const BalancesKpi = () => {
    const [kpiData, setKpiData] = useState({ data: null, loading: false, error: null });
    const [open, setOpen] = useState(false)
    const [balanceModalData, setBalanceModalData] = useState("")
    useEffect(() => {
        fetchKpiData();
    }, []);

    const fetchKpiData = async () => {
        setKpiData({ data: null, loading: true, error: null });
        try {
            const response = await getKpis('Balances/MasterBalances');
            if (response?.ok) {
                setKpiData({ data: response.data, loading: false, error: null });
            } else {
                throw new Error(apiCalls.isErrorDispaly(response));
            }
        } catch (error) {
            setKpiData({ data: null, loading: false, error: apiCalls.isErrorDispaly(error) });
        }
    };
    const openModel = useCallback((item) => () => {
        setOpen(true)
        setBalanceModalData(item)
    }, [])
    const closeModel = useCallback(() => {
        setOpen(false)
    }, [])
    const closeError = useCallback(() => {
        setKpiData({ ...kpiData, error: null });
    }, [kpiData]);
    return (
        <>

            {kpiData.error && (
                <Alert
                    className='mb-6'
                    type="error"
                    description={kpiData.error}
                    onClose={closeError}
                    showIcon
                    closable
                />
            )}
            <div className="border border-StrokeColor rounded-5 p-3.5">
                {kpiData.loading && <div className="w-full flex justify-end items-center "><Loader /></div>}
                {!kpiData.loading && kpiData?.data?.length > 0 && (
                    kpiData?.data?.map((item) => (
                        <>
                            {item.name !== "Cards Balance" && <div key={item?.name}>
                                <h3 className="text-lg text-paraColor font-normal">{item?.name}</h3>
                                <div className="grid grid-cols-2 gap-5">
                                    <div className="">
                                        <h4 className="text-xl text-subTextColor font-semibold cursor-pointer" onClick={openModel(item)}>
                                            <NumericFormat
                                                value={item?.balance || 0}
                                                displayType="text"
                                                thousandSeparator
                                                decimalScale={0}
                                                suffix={` ${item?.currency?.toUpperCase()}`}
                                                className="text-xl text-hoverColor font-semibold"
                                            />
                                        </h4>
                                    </div>

                                </div>
                            </div>}
                        </>
                    )))}</div>
            <div className="border border-StrokeColor rounded-5 p-3.5">
                {!kpiData.loading && kpiData?.data?.length > 0 &&
                    <div>
                        <h3 className="text-lg text-paraColor font-normal mb-1">{"Cards Balance"}</h3>
                        <div className="grid grid-cols-2 gap-6">{(kpiData?.data?.map((item) => (
                            <>
                                {item.name == "Cards Balance" && <div className="" key={item?.currency} >
                                    <div className="">
                                        <h4 className="text-base text-paraColor font-medium">
                                            {item?.currency?.toUpperCase()}
                                        </h4>
                                    </div>

                                    <div className="">
                                        <h4 className="text-lg  text-hoverColor font-semibold cursor-pointer" onClick={openModel(item)}>
                                            <NumericFormat
                                                value={item?.balance || 0}
                                                displayType="text"
                                                thousandSeparator
                                                prefix={item.symbol}
                                                decimalScale={0}
                                                className="text-lg text-hoverColor font-semibold"
                                            />
                                        </h4>
                                    </div>
                                </div>}

                            </>
                        )))}</div>
                    </div>}</div>
            {open && <ProgramsList open={open} closeModel={closeModel} kpiData={balanceModalData} />}
        </>
    );
};
export default BalancesKpi;
